import "reflect-metadata";
import "./styles/main.scss";
import { vueApp } from "@/core/dependency-injection";

vueApp.mount();
